module.exports = __webpack_public_path__ + "media/images/mamari/wowma/btn-already-yellow-bfeb4959e34642fe909e25fef28e239d.png";